export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4828.cbf37b1f.jpg";